import { logger } from './logger'
import { ObjectSchema, Schema } from 'joi'

export const validationUtil = {
  sanitize: <T>(objectToValidate: Partial<T> | any, schema: Schema<T> | ObjectSchema<T>): T => {
    try {
      const { error, value } = schema.validate(objectToValidate, {
        abortEarly: false,
        stripUnknown: true,
        allowUnknown: true,
      })
      if (error) {
        logger.warn('Validation sanitization warnings:', error.details)
      }
      return value
    } catch (err) {
      logger.error('Error during sanitization:', err as Error)
      throw err
    }
  },
  validate: <T>(objectToValidate: Partial<T> | any, schema: Schema<T> | ObjectSchema<T>): T => {
    try {
      const { error, value } = schema.validate(objectToValidate, {
        abortEarly: false,
        stripUnknown: false,
        allowUnknown: false,
      })
      if (error) {
        logger.error('Validation failed:', error.details)
        throw new Error(`Validation failed: ${error.details.map((d) => d.message).join(', ')}`)
      }
      return value
    } catch (err) {
      logger.error('Error during validation:', err as Error)
      throw err
    }
  },
}
